import client from './client';

export const getInvites = (params) => client.get('/invites', { params });

export const getInviteSummary = () => client.get('/invites/summary');

export const getInviteBenefitPolicy = () => client.get('/invites/policy');

export const updateInviteBenefitPolicy = (data) => client.put('/invites/policy', data);
